import React from "react";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
          Terms and Conditions
        </h1>

        <div className="prose prose-gray dark:prose-invert max-w-none leading-relaxed">
          <h2>
            Terms and Conditions for Madura Mercerisers India Private Limited
          </h2>

          <p>
            Please read these Terms and Conditions carefully before using our
            Service. By accessing or using the Service, You agree to be bound by
            these Terms and Conditions.
          </p>

          <h2>Interpretation and Definitions</h2>

          <h3>Interpretation</h3>
          <p>
            The words whose initial letters are capitalized have meanings
            defined under the following conditions. These definitions shall have
            the same meaning whether they appear in singular or plural.
          </p>

          <h3>Definitions</h3>
          <ul>
            <li>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by, or is under common control with a party, where
              "control" means ownership of 50% or more of the shares or voting
              securities.
            </li>
            <li>
              <strong>Country</strong> refers to: Tamil Nadu, India.
            </li>
            <li>
              <strong>Company</strong> (referred to as “the Company”, “We”, “Us”
              or “Our”) refers to{" "}
              <em>Madura Mercerisers India Private Limited</em>, No: 5/487 D,
              Angeripalayam Main Road, Vengamedu, Tirupur – 641 603.
            </li>
            <li>
              <strong>Device</strong> means any device that can access the
              Service such as a computer, a cell phone or a digital tablet.
            </li>
            <li>
              <strong>Service</strong> refers to the Website.
            </li>
            <li>
              <strong>Terms and Conditions</strong> (also referred to as
              “Terms”) mean these Terms and Conditions that form the entire
              agreement between You and the Company regarding the use of the
              Service.
            </li>
            <li>
              <strong>Website</strong> refers to{" "}
              <a
                href="https://www.maduramercerisers.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 underline"
              >
                www.maduramercerisers.com
              </a>
              .
            </li>
            <li>
              <strong>You</strong> means the individual accessing or using the
              Service, or the company or legal entity on whose behalf the
              Service is used.
            </li>
          </ul>

          <h2>Acknowledgment</h2>
          <p>
            These are the Terms and Conditions governing the use of this Service
            and the agreement between You and the Company. By accessing or using
            the Service, You agree to these Terms. If You disagree with any part
            of these Terms, You may not access the Service. You represent that
            You are over 18 years of age.
          </p>
          <p>
            Your access to and use of the Service is also conditioned on Your
            acceptance of and compliance with the Company’s{" "}
            <a
              href="/privacy-policy"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              Privacy Policy
            </a>
            .
          </p>

          <h2>Links to Other Websites</h2>
          <p>
            Our Service may contain links to third-party websites that are not
            owned or controlled by the Company. We have no responsibility for
            the content or privacy practices of any third-party websites. We
            advise You to read their terms and conditions and privacy policies.
          </p>

          <h2>Termination</h2>
          <p>
            We may terminate or suspend Your access immediately, without prior
            notice or liability, for any reason, including breach of these
            Terms. Upon termination, Your right to use the Service ceases
            immediately.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, the Company shall not be
            liable for any indirect, incidental, special, or consequential
            damages (including lost profits, data, or goodwill). The Company’s
            total liability shall not exceed the amount paid by You through the
            Service or USD 100 if no purchase was made.
          </p>

          <h2>“AS IS” and “AS AVAILABLE” Disclaimer</h2>
          <p>
            The Service is provided “AS IS” and “AS AVAILABLE” without
            warranties of any kind, whether express or implied, including
            implied warranties of merchantability, fitness for a particular
            purpose, title, or non-infringement. The Company does not warrant
            that the Service will be uninterrupted, error-free, or free of
            harmful components.
          </p>

          <h2>Governing Law</h2>
          <p>
            The laws of Tamil Nadu, India, excluding conflicts of law rules,
            will govern these Terms and Your use of the Service.
          </p>

          <h2>Dispute Resolution</h2>
          <p>
            If You have a dispute or concern regarding the Service, You agree to
            first attempt to resolve it informally by contacting the Company.
          </p>

          <h2>United States Legal Compliance</h2>
          <p>
            You represent that You are not located in a country subject to U.S.
            government sanctions and not listed on any U.S. prohibited parties
            list.
          </p>

          <h2>Severability and Waiver</h2>
          <p>
            If any provision of these Terms is held invalid, the remaining
            provisions shall continue in effect. Failure by either party to
            enforce a right or provision does not constitute a waiver of that
            right.
          </p>

          <h2>Translation Interpretation</h2>
          <p>
            These Terms may have been translated. The original English version
            shall prevail in any dispute.
          </p>

          <h2>Changes to These Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time.
            If the changes are material, we will provide at least 30 days’
            notice. Continued use of the Service after revisions indicates
            acceptance of the updated Terms.
          </p>

          <h2>Contact Us</h2>
          <p>
            If You have any questions about these Terms and Conditions, contact
            us through our website:&nbsp;
            <a
              href="https://www.maduramercerisers.com/ContactUs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              www.maduramercerisers.com/ContactUs
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
